import { useRepositoryQuery } from '@mews-commander/data-access';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';

export const useIsTaxWithholdingTabAvailable = () => {
    const taxWithholdingFFEnabled = useFeatureFlag(FeatureFlag.taxwithholdingConfigurationPage);
    const { data } = useRepositoryQuery(
        'accountingConfigurations',
        'getWithheldTaxes',
        {},
        {
            enabled: taxWithholdingFFEnabled,
        }
    );

    return data?.hasTaxWithholding ?? false;
};
